// extracted by mini-css-extract-plugin
export default {"pic":"newAccu_pic__QWjC9"};